import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import Swal from 'sweetalert2'
import LoginComponent from '../components/Account/LoginComponent.vue';
import UserSupport from '../components/UserSupport/UserSupport.vue';
import CourseSupport from '@/components/CourseSupport/CourseSupport.vue';
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'LoginComponent',
    component: LoginComponent
  },
  {
    path: '/user/support',
    name: 'UserSupport',
    component: UserSupport
  },
  {
    path: '/course/support',
    name: 'CourseSupport',
    component: CourseSupport
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem('userToken') !== null;

  if (to.path !== '/' && !isAuthenticated) {
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: "You are not logged in! Please log in to access this page."
    });
    next('/'); 
  }
  else {
    next();
  }
});

export default router
